export const setCookie = (
  name: string,
  value: string,
  days?: number,
  isSession?: boolean,
  path = '/',
  domain: string = '.cian.ru',
) => {
  const expires = days ? new Date(Date.now() + days * 864e5).toUTCString() : 0;
  const cookie = `${name}=${encodeURIComponent(value)}; path=${path}; domain=${domain}`;

  document.cookie = isSession ? cookie : `${cookie}; expires=${expires}`;
};

export const getCookie = (name: string) => {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');

    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');
};

export const deleteCookie = (name: string) => {
  setCookie(name, '', -1);
};
